/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import DashboardLayout from './layouts/DashboardLayout';
import CleanLayout from './layouts/CleanLayout';

const routes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/dashboard" />
  },
  {
    path: '/auth',
    component: CleanLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('./pages/login/login'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/dashboard',
        exact: true,
        component: lazy(() => import('./pages/dashboard/dashboard'))
      },
      {
        path: '/users',
        exact: true,
        component: lazy(() => import('./pages/users/users'))
      },
      {
        path: '/payments',
        exact: true,
        component: lazy(() => import('./pages/payments/payments'))
      },
      {
        path: '/proposals',
        exact: true,
        component: lazy(() => import('./pages/proposals/proposals'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];

export default routes;
